import { Component, computed, inject, output } from '@angular/core';

import { FinParcours } from '../../models/fin-parcours.model';
import { FinParcoursStore } from '../../store/fin-parcours/fin-parcours.store';

@Component({
  selector: 'app-parcours-fin',
  imports: [],
  templateUrl: './parcours-fin.component.html',
  styleUrl: './parcours-fin.component.scss',
})
export class ParcoursFinComponent {
  #finParcoursStore = inject(FinParcoursStore);

  readonly onClick = output<FinParcours>();

  protected finsParcours = computed(() => this.#finParcoursStore.entities());

  protected clickHandler(finParcours: FinParcours) {
    this.onClick.emit(finParcours);
  }
}
